import React from 'react'
import './style.css'
const index = () => {
    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }
  return (
    <div className="component-desc">
    <h2 className="heading">Alert</h2>
    <div className="description">An alert conveys an important message with very few words which notifies users about what action happened without interrupting them.</div>
    <div className="divider"></div>

    <div className="alert-container">
        <h4 className="heading">Success Alert</h4>
        <div style={{width:'75%', margin:'0 auto'}} className="alert alert-success">
            Transaction was successfull.
        </div>
        <div className="carbon-container">
            <iframe className="iframe"
                src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520class%253D%2522alert%2520alert-success%2522%253ETransaction%2520was%2520successfull.%253C%252Fdiv%253E"
                style={frameStyle}
                sandbox="allow-scripts allow-same-origin">
            </iframe>  
        </div>
        <div className="divider"></div>
        <h4 className="heading">Warning Alert</h4>
        <div style={{width:'75%', margin:'0 auto'}} className="alert alert-warning">
            Delete photo from gallery ?
        </div>
        <div className="carbon-container">
            <iframe className="iframe"
                src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520class%253D%2522alert%2520alert-warning%2522%253EDelete%2520photo%2520from%2520gallery%2520%253F%253C%252Fdiv%253E"
                style={frameStyle}
                sandbox="allow-scripts allow-same-origin">
            </iframe>
        </div>
        <div className="divider"></div>
        <h4 className="heading">Error Alert</h4>
        <div style={{width:'75%', margin:'0 auto'}} className="alert alert-error">
            Oops!!! Something went wrong.
        </div>
        <div className="carbon-container">
            <iframe className="iframe"
                src="https://carbon.now.sh/embed?bg=rgba%28248%2C231%2C28%2C1%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=%253Cdiv%2520class%253D%2522alert%2520alert-error%2522%253EOops%21%21%21%2520Something%2520went%2520wrong.%253C%252Fdiv%253E"
                style={frameStyle}
                sandbox="allow-scripts allow-same-origin">
            </iframe>
        </div>
    </div>
    </div>
  )
}

export default index